import type { StringKeyOf } from 'type-fest';

export type SnowplowSchemaName = StringKeyOf<typeof SNOWPLOW_SCHEMAS>;

export const SNOWPLOW_SCHEMAS = {
  alerts_notification_action:
    'iglu:com.klue/alerts_notification_action/jsonschema/1-0-0',
  ask_klue_interaction: 'iglu:com.klue/ask_klue_interaction/jsonschema/1-0-9',
  ask_klue_suggest: 'iglu:com.klue/ask_klue_suggest/jsonschema/1-0-0',
  artifact: 'iglu:com.klue/artifact/jsonschema/1-0-0',
  aspect: 'iglu:com.klue/aspect/jsonschema/1-0-0',
  battlecard: 'iglu:com.klue/battlecard/jsonschema/1-0-1',
  board: 'iglu:com.klue/board/jsonschema/2-0-3',
  boardfilter: 'iglu:com.klue/boardfilter/jsonschema/1-0-0',
  call: 'iglu:com.klue/call/jsonschema/1-0-0',
  call_data_sync_auth_modified:
    'iglu:com.klue/call_data_sync_auth_modified/jsonschema/1-0-0',
  call_data_sync_configuration_complete:
    'iglu:com.klue/call_data_sync_configuration_complete/jsonschema/1-0-1',
  call_data_sync_toggled:
    'iglu:com.klue/call_data_sync_toggled/jsonschema/1-0-0',
  card: 'iglu:com.klue/card/jsonschema/1-0-4',
  card_103: 'iglu:com.klue/card/jsonschema/1-0-3',
  card_interaction: 'iglu:com.klue/card_interaction/jsonschema/1-0-11',
  chat_feedback_prompt_action:
    'iglu:com.klue/chat_feedback_prompt_action/jsonschema/1-0-0',
  chat_message: 'iglu:com.klue/chat_message/jsonschema/1-0-0',
  chat_session: 'iglu:com.klue/chat_session/jsonschema/1-0-0',
  chatbot_copy_action: 'iglu:com.klue/chatbot_copy_action/jsonschema/1-0-0',
  chatbot_followup_action:
    'iglu:com.klue/chatbot_followup_action/jsonschema/1-0-0',
  compete_answer_comparison_action:
    'iglu:com.klue/compete_answer_comparison_action/jsonschema/1-0-0',
  comment: 'iglu:com.klue/comment/jsonschema/1-0-0',
  company: 'iglu:com.klue/company/jsonschema/1-0-0',
  competitive_dashboard_action:
    'iglu:com.klue/competitive_dashboard_action/jsonschema/1-0-0',
  composer_card: 'iglu:com.klue/composer_card/jsonschema/1-0-0',
  composer_card_action: 'iglu:com.klue/composer_card_action/jsonschema/1-0-1',
  dashboard_tile_action: 'iglu:com.klue/dashboard_tile_action/jsonschema/1-0-0',
  data_sync_auth_modified:
    'iglu:com.klue/data_sync_auth_modified/jsonschema/1-0-0',
  data_sync_configuration_complete:
    'iglu:com.klue/data_sync_configuration_complete/jsonschema/1-0-0',
  deal_tip: 'iglu:com.klue/deal_tip/jsonschema/1-0-0',
  deal_tip_flag: 'iglu:com.klue/deal_tip_flag/jsonschema/1-0-0',
  // Intel Digest 2.0 (ENG-3782). Split by what each event must validate:
  // a take action carries its previous author, an addition carries method
  // and outcome, and everything that needs nothing but its own name shares
  // `digest_action`.
  digest_action: 'iglu:com.klue/digest_action/jsonschema/1-0-0',
  digest_story_add: 'iglu:com.klue/digest_story_add/jsonschema/1-0-0',
  digest_take_action: 'iglu:com.klue/digest_take_action/jsonschema/1-0-0',
  drive_data_sync_auth_modified:
    'iglu:com.klue/drive_data_sync_auth_modified/jsonschema/1-0-0',
  drive_data_sync_configuration_complete:
    'iglu:com.klue/drive_data_sync_configuration_complete/jsonschema/1-0-0',
  impression: 'iglu:com.klue/impression/jsonschema/1-0-5',
  insight: 'iglu:com.klue/insight/jsonschema/1-0-1',
  insightfilter: 'iglu:com.klue/insightfilter/jsonschema/1-0-0',
  insights_action: 'iglu:com.klue/insights_action/jsonschema/1-0-7',
  integration: 'iglu:com.klue/integration/jsonschema/1-0-0',
  integration_card_action:
    'iglu:com.klue/integration_card_action/jsonschema/1-0-1',
  intel: 'iglu:com.klue/intel/jsonschema/1-0-5',
  intel_action: 'iglu:com.klue/intel_action/jsonschema/1-0-6',
  intelfilter: 'iglu:com.klue/intelfilter/jsonschema/1-0-6',
  landing_page_action: 'iglu:com.klue/landing_page_action/jsonschema/1-0-3',
  lane: 'iglu:com.klue/lane/jsonschema/1-0-0',
  org_unit: 'iglu:com.klue/org_unit/jsonschema/1-0-0',
  review: 'iglu:com.klue/review/jsonschema/1-0-0',
  reviewfilter: 'iglu:com.klue/reviewfilter/jsonschema/1-0-2',
  search_action: 'iglu:com.klue/search_action/jsonschema/1-0-3',
  supported_rival: 'iglu:com.klue/supported_rival/jsonschema/1-0-0',
  tag: 'iglu:com.klue/tag/jsonschema/1-0-0',
  user: 'iglu:com.klue/user/jsonschema/1-0-0',
};
